module.exports = __webpack_public_path__ + "static/img/10-2.19863cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10-2.jpg
// module id = 10Br
// module chunks = 0